import React, { Fragment } from "react";
import * as nls from "../nls";
import { i18n } from "@src/utils/i18n";
import BaseInfo from "../page/baseInfo";
import Members from "../page/members";
import Editions from "../page/versionManageRelease";
import ApiManage from "../page/apiManage";
import AddAppCapabilities from "../page/addAppCapabilities";
import ApplicationWe from "../page/applicationWe";
import ApplicationLight from "../page/applicationLight";
import ApplicationRobot from "../page/applicationRobot";
import EventsAndCallbacks from "../page/eventsAndCallbacks";
import SecuritySet from '../page/securitySet';
const I18N = i18n(nls);

export const routerConfig = {
  // 基本信息
  baseInfo: "/baseInfo",
  // 成员信息
  membersManage: "/membersManage",
  // 添加应用能力
  addAppCapabilities: "/addAppCapabilities",
  // We码
  applicationWe: "/applicationWe",
  // 轻应用
  applicationLight: "/applicationLight",
  // 机器人
  applicationRobot: "/applicationRobot",
  // 权限管理
  apiManage: "/apiManage",
  // 事件回调
  eventsAndCallbacks: "/eventsAndCallbacks",
  // 版本管理和发布
  editionManage: "/editionManage",
  securitySet: '/securitySet',
};

const routerList = [
  {
    // 基本信息
    name: I18N.baseInfo,
    path: routerConfig.baseInfo,
    component: props => (
      <Fragment>
        <BaseInfo {...props} />
      </Fragment>
    )
  },
  {
    // 成员管理
    name: I18N.membersManage,
    path: routerConfig.membersManage,
    component: props => (
      <Fragment>
        <Members {...props} />
      </Fragment>
    )
  },
  {
    // 添加应用功能
    name: I18N.addAppCapabilities,
    path: routerConfig.addAppCapabilities,
    component: props => (
      <Fragment>
        <AddAppCapabilities {...props} />
      </Fragment>
    )
  },
  {
    // we码
    name: I18N.applicationWe,
    path: routerConfig.applicationWe,
    component: props => (
      <Fragment>
        <ApplicationWe {...props} />
      </Fragment>
    )
  },
  {
    // 轻应用
    name: I18N.applicationLight,
    path: routerConfig.applicationLight,
    component: props => (
      <Fragment>
        <ApplicationLight {...props} />
      </Fragment>
    )
  },
  {
    // 机器人
    name: I18N.applicationRobot,
    path: routerConfig.applicationRobot,
    component: props => (
      <Fragment>
        <ApplicationRobot {...props} />
      </Fragment>
    )
  },
  {
    // 版本管理
    name: I18N.editionManage,
    path: routerConfig.editionManage,
    component: props => (
      <Fragment>
        <Editions {...props} />
      </Fragment>
    )
  },
  {
    // 权限申请
    name: I18N.powerManage,
    path: routerConfig.apiManage,
    component: props => (
      <Fragment>
        <ApiManage {...props} />
      </Fragment>
    )
  },
  {
    // 事件与回调
    name: I18N.eventsAndCallbacks,
    path: routerConfig.eventsAndCallbacks,
    component: props => (
      <Fragment>
        <EventsAndCallbacks {...props} />
      </Fragment>
    )
  },
  {
    name: I18N.securitySet,
    path: routerConfig.securitySet,
    component: props => (
      <Fragment>
        <SecuritySet {...props} />
      </Fragment>
    )
  }
];
routerList.map(item => {
  item.route = "*" + item.path;
  item.title = "submitPreAudit";
});

export default routerList;
